"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=4053%3A456))
 * @trackcomponent
 * @lastsynced 2023-11-30T15:50:27.712Z
 */
export const Exclusivity = createSVGIcon(
  <>
    <path
      d="M21 10.2719C21 16.9265 14.3249 21.6701 12.4718 22.859C12.3306 22.9511 12.1669 23 11.9997 23C11.8326 23 11.6689 22.9511 11.5277 22.859C9.67557 21.6701 3 16.926 3 10.2719C3 5.15116 7.02945 1 12 1C16.9706 1 21 5.15116 21 10.2719Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.20118 9.71233L10.7758 8.77516L11.7123 6.20118C11.7338 6.14222 11.7729 6.09128 11.8243 6.05529C11.8757 6.0193 11.9369 6 11.9997 6C12.0624 6 12.1237 6.0193 12.1751 6.05529C12.2265 6.09128 12.2656 6.14222 12.2871 6.20118L13.2242 8.77578L15.7988 9.71233C15.8578 9.7338 15.9087 9.77289 15.9447 9.8243C15.9807 9.87571 16 9.93694 16 9.99969C16 10.0624 15.9807 10.1237 15.9447 10.1751C15.9087 10.2265 15.8578 10.2656 15.7988 10.2871L13.2236 11.2242L12.2871 13.7988C12.2656 13.8578 12.2265 13.9087 12.1751 13.9447C12.1237 13.9807 12.0624 14 11.9997 14C11.9369 14 11.8757 13.9807 11.8243 13.9447C11.7729 13.9087 11.7338 13.8578 11.7123 13.7988L10.7752 11.2236L8.20118 10.2871C8.14222 10.2656 8.09128 10.2265 8.05529 10.1751C8.0193 10.1237 8 10.0624 8 9.99969C8 9.93694 8.0193 9.87571 8.05529 9.8243C8.09128 9.77289 8.14222 9.7338 8.20118 9.71233Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Exclusivity",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
